export const dateSerializer = (value: string) => `${value}+00:00`;
